import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { Router } from '@angular/router';
import { Route } from '../../interfaces/route';
import { StopsService } from '../../services/stops.service';
import { RouteService } from '../../services/route.service';
import { ScheduleService } from '../../services/schedule.service';
import { GlobalVariables } from '../../common/global-variables';
import { KmlService } from '../../services/kml.service';
import { TripsService } from '../../services/trips.service';
import { timer } from 'rxjs';
import { MapService } from '../../services/map.service';
import { MarkersService } from '../../services/markers.service';

@Component({
  selector: 'app-trip-schedules',
  templateUrl: './trip-schedules.component.html',
  styleUrls: ['./trip-schedules.component.css']
})
export class TripSchedulesComponent implements OnInit {
  public trip_id: string;
  public schedule: any = [{ 'block_id': null, trip_headsign: "" }];
  public routes: any;
  public route_id: string;
  public route_name: string;
  public trip_headsign: string;
  public start_time: string;
  public end_time: string;
  public current_stop: string;
  public next_stop_id: string;
  public next_stop_name: string;
  public next_stop_sequence: string;
  public car_count: number;
  public cars: string;
  public vehicle: string;
  public type: string;
  public realtime: any;
  public late: number;
  public status: string = "Scheduled";
  public estimated_seat_availability: string;
  public estimated_seat_availability_html: string;
  public transitRefresh: any;

  public embedded_map: any;

  constructor(private route: ActivatedRoute, private stopsService: StopsService, private routeService: RouteService, private scheduleService: ScheduleService, private mapService: MapService, private kmlService: KmlService, private markersService: MarkersService, private tripsService: TripsService) { }

  ngOnInit(): void {
    this.trip_id = this.route.snapshot.paramMap.get('trip');
    if (this.trip_id != "") {
      this.getSchedule(this.trip_id);
    }
  }

  getSchedule(trip: any): void {
    this.stopsService.getTripStopTimes(trip)
      .subscribe(schedule => {

        this.schedule = schedule;

        this.route_id = schedule[0].route_id;
        this.trip_headsign = schedule[0].trip_headsign;
        this.start_time = schedule[0].arrival_time;
        this.end_time = schedule[schedule.length - 1].arrival_time;

        this.getRoutes();

        this.getRealtime(this.route_id, schedule);

        this.kmlService.set(this.route_id, false);

      });
  }

  getRoutes(): void {
    this.routeService.get()
      .subscribe(routes => {
        this.routes = routes;

        for (let i in routes) {
          if (routes[i].id == this.route_id) {
            this.route_name = routes[i].name;
          }
        }

        this.realtime = this.routeService.realtime;
      });
  }

  getRealtime(route_id: string, schedule: any = null): void {
    this.scheduleService.get_realtime_status(route_id).subscribe(trips => {
      var extracted_trips = Object.entries(trips);
      for (let trip in extracted_trips) {

        var trip_id = extracted_trips[trip][1].trip;
        var requested_trip_id = this.trip_id.split("_").pop();
        var mode = 'bus'

        if (GlobalVariables.railRoutes.includes(route_id)) {
          requested_trip_id = this.trip_id.split("_")[2];
          mode = 'rail'
        }

        if (requested_trip_id == trip_id) {

          var seat_estimate = 'No Estimate';
              var many_seats = "MANY_SEATS_AVAILABLE";
              var few_seats = "FEW_SEATS_AVAILABLE";
              var standing_seats = "STANDING_ROOM_ONLY";

          if(extracted_trips[trip][1].estimated_seat_availability == many_seats){
            seat_estimate = 'Many Seats';
          }
          if(extracted_trips[trip][1].estimated_seat_availability == few_seats){
            seat_estimate = 'Few Seats';
          }
          if(extracted_trips[trip][1].estimated_seat_availability == standing_seats){
            seat_estimate = 'Standing room only';
          }

          this.next_stop_name = extracted_trips[trip][1].next_stop_name;
          this.next_stop_sequence = extracted_trips[trip][1].next_stop_sequence;
          this.next_stop_id = extracted_trips[trip][1].next_stop_id;
          this.late = extracted_trips[trip][1].late;
          this.status = this.scheduleService.format_status(this.late);
          this.estimated_seat_availability = extracted_trips[trip][1].estimated_seat_availability;
          this.estimated_seat_availability_html = seat_estimate;
          this.vehicle = extracted_trips[trip][1].VehicleID;
          this.cars = extracted_trips[trip][1].cars;
          this.car_count = this.cars != null ? this.cars.split(",").length : null;
          this.type = extracted_trips[trip][1].type;

          if (this.next_stop_sequence == null) {
            for (const stop of schedule) {
              if (stop.stop_name == this.next_stop_name) {
                this.next_stop_id = stop.stop_id;
                this.next_stop_sequence = stop.stop_sequence;
              }
            }
          }

          this.tripsService.get(requested_trip_id, mode, route_id).subscribe();
        }
      }

      return false;
    });
  }

  ngOnDestroy() {
    if( typeof this.tripsService.transitRefresh != "undefined"){
      this.markersService.clearMarkers(this.mapService.map);
      this.tripsService.transitRefresh.unsubscribe();
    }
  }

}
